export default "__VITE_ASSET__ea75e03a__"